module.exports = __webpack_public_path__ + "media/images/twitter_follow_and_retweet/get-badge-87a9d22e28b4463f2cae64051b9cf354.png";